/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {LargeButtonsAndIconsExample, ExtendedExample} from 'Docs/uilib/usage/customisation/Examples';
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    p: "p",
    a: "a",
    code: "code",
    h2: "h2",
    strong: "strong"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h1, {
      children: "Component Properties"
    }), "\n", _jsxs(_components.p, {
      children: ["Every ", _jsx(_components.a, {
        href: "/uilib/components",
        children: "Component"
      }), " has its own ", _jsx(_components.code, {
        children: "properties"
      }), " to make them work for a variety of cases. You may have a look at the table describing all the possibilities. Check out for example the ", _jsx(_components.a, {
        href: "/uilib/components/button/properties",
        children: "Button Properties"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      children: "Naming"
    }), "\n", _jsxs(_components.p, {
      children: ["Both the properties- and event names should use ", _jsx(_components.strong, {
        children: "camelCase"
      }), " to support a universal ", _jsx(_components.a, {
        href: "/contribute/style-guides/naming",
        children: "naming convention"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      children: "Large Buttons & Icons"
    }), "\n", _jsx(_components.p, {
      children: "Below are some examples. You can even modify them right away in the Browser."
    }), "\n", _jsx(LargeButtonsAndIconsExample, {}), "\n", _jsx(_components.h2, {
      children: "Extended example"
    }), "\n", _jsx(ExtendedExample, {})]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
